var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tags),function(tag){return _c('md-chip',{key:tag.id,style:(_vm.chipStyle(tag.color))},[_vm._v(_vm._s(tag.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }